import { EntityTypes } from '@/helpers/entityType';

export const contentTypeParam = {
  academy: 'academy',
  artFair: 'art_fair',
  artSpace: 'museum_gallery',
  artTrip: 'art_trip',
  destination: 'destination',
  event: 'event',
  exhibition: 'exhibition',
  experience: 'experience',
  historicalSite: 'historical_site',
  insiderTip: 'insider_tip',
  itinerary: 'itinerary',
  miniCultivist: 'mini_cultivist',
  story: 'story',
  virtualLibrary: 'virtual_library',
};

export function getContentTypeFromEntityType(entityType: string) {
  const map: { [key: string]: string } = {
    [EntityTypes.academy]: contentTypeParam.academy,
    [EntityTypes.art_fair]: contentTypeParam.artFair,
    [EntityTypes.art_space]: contentTypeParam.artSpace,
    [EntityTypes.art_trip]: contentTypeParam.artTrip,
    [EntityTypes.destination]: contentTypeParam.destination,
    [EntityTypes.event]: contentTypeParam.event,
    [EntityTypes.exhibition]: contentTypeParam.exhibition,
    [EntityTypes.experience]: contentTypeParam.experience,
    [EntityTypes.historical_site]: contentTypeParam.historicalSite,
    [EntityTypes.insider_tip]: contentTypeParam.insiderTip,
    [EntityTypes.insider_tip_element]: contentTypeParam.insiderTip,
    [EntityTypes.itinerary]: contentTypeParam.itinerary,
    [EntityTypes.mini_cultivist]: contentTypeParam.miniCultivist,
    [EntityTypes.story]: contentTypeParam.story,
    [EntityTypes.virtual_library_item]: contentTypeParam.virtualLibrary,
  };

  return map[entityType];
}
